import FamilyRecordsModule from '../components/FamilyRecordsModule'

export default function ItemsControl(){
 return <FamilyRecordsModule module="items"/>
}
